import { render, staticRenderFns } from "./PtrSidebar.vue?vue&type=template&id=3ba60813&scoped=true&"
import script from "./PtrSidebar.vue?vue&type=script&lang=js&"
export * from "./PtrSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PtrSidebar.vue?vue&type=style&index=0&id=3ba60813&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba60813",
  null
  
)

export default component.exports